import React from 'react';
import { Box, Typography } from '@mui/material';
import ColorPicker from './ColorPicker';
import { useFormTheme } from '../../../contexts/FormThemeContext'; // Adjust the import path as necessary

const ThemeColors = () => {
  const { colors, handleChangeColor } = useFormTheme(); // Use context to access colors and handler
  if (!colors) return null;

  // Mapping state keys to user-friendly labels
  const labelMap = {
    backgroundColor: 'Background',
    activeColor: 'Active',
    textColor: 'Text',
    warningColor: 'Warning'
  };

  return (
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between', // Ensures that elements are evenly distributed
      m: 0,
      p: '0 2px 0 2px',
    }}>
      {Object.entries(colors).map(([key, color]) => (
        <Box key={key} sx={{
          width: '48%', // Each box will take up less than half of the row width
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mb: 0, // Adds some vertical margin between rows
          p: 0,  // Ensures there's no padding around the box
        }}>
          <ColorPicker color={color} onChange={handleChangeColor(key)} />
          <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 300, fontSize: '0.75rem' }}>
            {labelMap[key]}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ThemeColors;
